var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTransferFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 26 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.474 10.283 1.122 1.104L25 6.619 20.59 2l-1.103 1.117 2.587 2.711H2.571v1.594h19.551l-2.648 2.861ZM3.92 18.165l2.593 2.711L5.41 22 1 17.375l4.404-4.762 1.122 1.097-2.643 2.86h19.592v1.595H3.921Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.474 10.283 1.122 1.104L25 6.619 20.59 2l-1.103 1.117 2.587 2.711H2.571v1.594h19.551l-2.648 2.861ZM3.92 18.165l2.593 2.711L5.41 22 1 17.375l4.404-4.762 1.122 1.097-2.643 2.86h19.592v1.595H3.921Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTransferFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TransferFilled.853f0764975f35503e1e2176afe79181.svg";